<template>
  <div>
    <MMP_DPR_SerialNumberChange
      :incomingData="incomingData"
      :user="user"
      @updateSystems="updateSystems($event)"
    ></MMP_DPR_SerialNumberChange>

    <MMP_DPR_Decommission
      :incomingData="incomingData"
      @updateSystems="updateSystems($event)"
    ></MMP_DPR_Decommission>

    <MMP_DPR_UpdateVehicle
      :vehicle="vehicleToUpdate"
      :user="user"
      @refresh="getVehicles()"
    ></MMP_DPR_UpdateVehicle>

    <MMP_DPR_DecommissionVehicle
      :vehicle="vehicleToDecommission"
      :user="user"
      @refresh="getVehicles()"
    ></MMP_DPR_DecommissionVehicle>

    <MMP_DPR_RecommissionVehicle
      :vehicle="vehicleToRecommission"
      :user="user"
      @refresh="getVehicles()"
    ></MMP_DPR_RecommissionVehicle>

    <MMP_DPR_NewVehicle
      :user="user"
      @refresh="getVehicles()"
    ></MMP_DPR_NewVehicle>

    <b-modal
      id="updatedNewSystemConfirmation"
      size="md"
      content-class="sub-menu-bg-blue-transparent"
      title="New System Confirmation"
      hide-footer
     
    >
      <b-container>
        <b-row class="py-2">
          <b-row class="py-2">
            <b-col v-if="updateNewSystemForm.install_date">
              System '<b>{{ this.updateNewSystemForm.system }}</b
              >' with Scanner <b>{{ this.updateNewSystemForm.scanner }}</b>, Serial
              Number '<b>{{ this.updateNewSystemForm.scannerSerialNumber }}</b>', and Install Date of <b>{{ this.updateNewSystemForm.install_date.toLocaleDateString(
                "en-US", { year: 'numeric', month: "2-digit", day: "2-digit"}
              ) }}</b> will be added to the database.
            </b-col>
          </b-row>
          <b-row class="py-2">
            <b-col>
              Click submit if these values are correct, or exit out of this
              panel to make changes.
            </b-col>
          </b-row>
          <b-row class="row-input py-2">
            <b-col class="text-center">
              <b-button
                variant="primary"
                size="lg"
                type="submit"
                @click="submitUpdatedNewSystemForm()"
              >
                Confirm and Submit
              </b-button>
            </b-col>
          </b-row>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal
      id="adminConsoleModal"
      size="xl"
      content-class="menu-bg-blue-transparent-modal dpr-admin-modal"
      title="Daily Productivity Report Admin Console"
      hide-footer
     
      @show="loadAdminConsole"
    >
      <b-container fluid>
        <b-tabs align="center" pills card v-model="activeTab">
          <!-- Operators Tab -->
          <b-tab id="operators" title="Operators">
            <b-row class="pb-3" align-v="center" align-h="center">
              <b-form-checkbox
                v-model="hideInactive"
                checked="true"
                :switch="true"
                @change="getOperators()"
              >
                Hide Inactive Operators
              </b-form-checkbox>
            </b-row>
            <b-row class="p-3" v-if="newOperatorSuccess" id="NewOperatorSuccessWindow">
              <b-col class="text-center">
                <span class="alert alert-success">
                  <b>{{ this.newOperatorSuccess }}</b>
                </span>
                <span class="btn" @click="newOperatorSuccessHide()">
                  <fa :icon="['fas', 'window-close']" />
                </span>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <vue-bootstrap4-table
                  :rows="operators"
                  :columns="operatorColumns"
                  :config="operatorConsoleConfig"
                  :actions="actions"
                  :classes="classes"
                  @newUser="initNewUserModal()"
                >
                  <template slot="name" slot-scope="props">
                    <div
                      v-if="!props.row.update"
                      :class="{inactive: props.row.deleted_date}"
                    >
                      <span>{{ props.row.name }}</span>
                    </div>
                    <!-- <div v-if="props.row.update">
                      <b-form-input type="text" v-model="props.row.name" />
                      <b-button
                        class="btn btn-success pt-1"
                        @click="changeOperatorName(props.row)"
                      >
                        <fa :icon="['fas', 'check']" />
                      </b-button>
                      <b-button
                        class="btn btn-danger pt-1"
                        @click="cancelChangeOperatorName(props.row)"
                      >
                        <fa :icon="['fas', 'times']" />
                      </b-button>
                    </div> -->
                  </template>
                  <template slot="group" slot-scope="props">
                    <div
                      v-if="!props.row.update"
                      :class="{inactive: props.row.deleted_date}"
                    >
                      <span>{{ props.row.group }}</span>
                    </div>
                  </template>
                  <template slot="deleted_date" slot-scope="props">
                    <div v-if="props.row.deleted_date">
                      <span>{{
                        formatDateForDisplay(props.row.deleted_date)
                      }}</span>
                      <span>
                        <small
                          ><b-button
                            class="btn btn-warning btn-sm"
                            @click="reactivateOperator(props.row)"
                          >
                            Reactivate
                          </b-button>
                        </small>
                      </span>
                    </div>
                  </template>
                  <template slot="update" slot-scope="props">
                    <button
                      class="btn btn-blue"
                      @click="updateOperatorDetails(props.row)"
                      :disabled="props.row.deleted_date"
                    >
                      <fa :icon="['fas', 'pencil-alt']" size="lg" />
                    </button>
                  </template>
                  <template slot="delete" slot-scope="props">
                    <button
                      class="btn btn-blue"
                      @click="deleteOperator(props.row)"
                      :disabled="props.row.deleted_date"
                    >
                      <fa :icon="['fas', 'minus']" size="lg" />
                    </button>
                  </template>
                </vue-bootstrap4-table>
              </b-col>
            </b-row>
          </b-tab>
          <!-- Road Type Tab -->
          <b-tab id="road-type" title="Road Type">
            <b-row class="pb-3" align-v="center" align-h="center">
              <b-col cols="4">
                <b-form-input
                  id="newRoadTypeInput"
                  placeholder="New Road Type"
                  v-model="newRoadTypeInput"
                />
              </b-col>
              <b-col cols="4">
                <b-button variant="success" @click="newRoadType()">
                  Add
                </b-button>
              </b-col>
            </b-row>
            <b-row class="p-3" v-if="newRoadTypeSuccess" id="NewRoadTypeSuccessWindow">
              <b-col class="text-center">
                <span class="alert alert-success">
                  <b>{{ this.newRoadTypeSuccess }}</b>
                </span>
                <span class="btn" @click="newRoadTypeSuccessHide()">
                  <fa :icon="['fas', 'window-close']" />
                </span>
              </b-col>
            </b-row>
            <b-row class="p-3" v-if="updateRoadTypeSuccess" id="UpdateRoadTypeSuccessWindow">
              <b-col class="text-center">
                <span class="alert alert-success">
                  <b>{{ this.updateRoadTypeSuccess }}</b>
                </span>
                <span class="btn" @click="updateRoadTypeSuccessHide()">
                  <fa :icon="['fas', 'window-close']" />
                </span>
              </b-col>
            </b-row>
            <b-row class="p-3" v-if="deleteRoadTypeSuccess" id="DeleteRoadTypeSuccessWindow">
              <b-col class="text-center">
                <span class="alert alert-success">
                  <b>{{ this.deleteRoadTypeSuccess }}</b>
                </span>
                <span class="btn" @click="deleteRoadTypeSuccessHide()">
                  <fa :icon="['fas', 'window-close']" />
                </span>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <vue-bootstrap4-table
                  :rows="roadTypes"
                  :columns="roadTypeColumns"
                  :config="roadTypeConsoleConfig"
                  :classes="classes"
                >
                  <template slot="type" slot-scope="props">
                    <div v-if="!props.row.update">
                      <span>{{ props.row.type }}</span>
                    </div>
                    <div v-if="props.row.update">
                      <b-form-input type="text" v-model="props.row.type" />
                      <b-button
                        class="btn btn-success pt-1"
                        @click="changeRoadTypeName(props.row)"
                      >
                        <fa :icon="['fas', 'check']" />
                      </b-button>
                      <b-button
                        class="btn btn-danger pt-1"
                        @click="cancelChangeRoadTypeName(props.row)"
                      >
                        <fa :icon="['fas', 'times']" />
                      </b-button>
                    </div>
                  </template>
                  <template slot="update" slot-scope="props">
                    <b-button
                      class="btn btn-blue"
                      @click="updateRoadType(props.row)"
                    >
                      <fa :icon="['fas', 'pencil-alt']" size="lg" />
                    </b-button>
                  </template>
                  <template slot="delete" slot-scope="props">
                    <b-button
                      class="btn btn-blue"
                      @click="deleteRoadType(props.row)"
                    >
                      <fa :icon="['fas', 'minus']" size="lg" />
                    </b-button>
                  </template>
                </vue-bootstrap4-table>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab id="new-system" title="New System">
            <b-container class="new-form-container">
              <!-- System -->
              <b-row class="row-input py-2">
                <b-col align-self="center" class="row-label-right-justify">
                  System Name
                </b-col>
                <b-col>
                  <b-form-input v-model="updateNewSystemForm.system" />
                </b-col>
              </b-row>
              <!-- Region -->
              <b-row class="row-input py-2">
                <b-col align-self="center" class="row-label-right-justify">
                  System Type
                </b-col>
                <b-col>
                  <b-form-select :options="systemTypeOptions" v-model="updateNewSystemForm.system_type" >
                    <template #first>
                      <b-form-select-option :value="null" disabled>
                        Select System Type
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-col>
              </b-row>
              <!-- Scanner -->
              <b-row class="row-input py-2">
                <b-col align-self="center" class="row-label-right-justify">
                  Scanner
                </b-col>
                <b-col>
                  <b-form-input
                    v-model="updateNewSystemForm.scanner"
                    type="number"
                    number
                    min="0"
                    max="2"
                  />
                </b-col>
              </b-row>
              <!-- Scanner Serial Number -->
              <b-row class="row-input py-2">
                <b-col align-self="center" class="row-label-right-justify">
                  Scanner Serial Number
                </b-col>
                <b-col>
                  <b-form-input v-model="updateNewSystemForm.scannerSerialNumber" />
                </b-col>
              </b-row>
              <!-- Region -->
              <b-row class="row-input py-2">
                <b-col align-self="center" class="row-label-right-justify">
                  Region
                </b-col>
                <b-col>
                  <b-form-select :options="regionOptions" v-model="updateNewSystemForm.region" >
                    <template #first>
                      <b-form-select-option :value="null" disabled>
                        Select Region
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-col>
              </b-row>
              <!-- Installment Date -->
              <b-row class="row-input py-2">
                <b-col align-self="center" class="row-label-right-justify">
                  Install Date
                </b-col>
                <b-col>
                  <b-form-datepicker 
                    v-model="updateNewSystemForm.install_date" 
                    locale="en" 
                    placeholder="MM/DD/YYYY"
                    :value-as-date="true"
                    :date-format-options="{ month: '2-digit', day: '2-digit', year: 'numeric'}"
                  />
                </b-col>
              </b-row>
              <!-- Submit button -->
              <b-row class="submit py-2">
                <b-col>
                  <b-button
                    variant="primary"
                    size="lg"
                    type="submit"
                    @click="showUpdatedNewSystemConfirmation()"
                  >
                    Submit
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </b-tab>
          <b-tab title="Vehicles">
            <b-row>
              <b-col>
                <!-- Loading Spinner -->
                <div class="d-flex justify-content-center py-1" v-if="!this.dataLoaded">
                  <span
                    class="spinner-border spinner-border-md highlightLoader"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span class="highlightLoader p-1 spinner-border-md">Loading Data...</span>
                </div>
                <div v-else>
                  <div class="tableHeader">
                    <b-form-checkbox-group class="checkboxes" v-model="vehiclesSelectedRegions">
                      <b-form-checkbox class="custom-checkbox" size="lg" value="North America">NA</b-form-checkbox>
                      <b-form-checkbox size="lg" value="Europe">EU</b-form-checkbox>
                      <b-form-checkbox size="lg" value="South Korea">SK</b-form-checkbox>
                      <b-form-checkbox size="lg" value="Japan">JP</b-form-checkbox>
                      <b-form-checkbox size="lg" value="Middle East">ME</b-form-checkbox>
                       <!--  <b-form-checkbox size="lg" value="Australia">AUS</b-form-checkbox> -->
                    </b-form-checkbox-group>
                    <!-- Active / Inactive toggle -->
                    <div class="mm-field">
                      <!-- <label class="mm-label">Status</label> -->
                      <div class="vehicles-status-toggle">
                        <div
                          class="vehicle-toggle-indicator"
                          :style="{
                            transform: `translateX(${activeVehicleFlag ? 0 : 100}%)`,
                            background: '#007bff'
                          }"
                        ></div>
                        <button type="button" class="vehicle-toggle-btn white-text" :class="{ active: activeVehicleFlag }" @click="activeVehicleFlag = true">
                          Active
                        </button>
                        <button type="button" class="vehicle-toggle-btn white-text" :class="{ active: !activeVehicleFlag }" @click="activeVehicleFlag = false">
                          Inactive
                        </button>
                      </div>
                    </div>
                  </div>
                  <vue-bootstrap4-table
                    :rows="filteredVehicles"
                    :columns="activeVehicleFlag ? activeVehiclesColumns : inactiveVehiclesColumns"
                    :config="systemConsoleConfig"
                    :classes="classes"
                    :actions="vehiclesActions"
                    @newVehicle="$bvModal.show('newVehicleModal')"
                  >
                    <template slot="vehicle_name" slot-scope="props">
                      <div>
                        <span>{{ props.row.vehicle_name }}</span>
                      </div>
                    </template>
                    <template slot="region" slot-scope="props">
                      <div>
                        <span>{{ props.row.region }}</span>
                      </div>
                    </template>
                    <template slot="updated_user" slot-scope="props">
                      <div>
                        <span>{{ props.row.updated_user }}</span>
                      </div>
                    </template>
                    <template slot="decommissioned_date" slot-scope="props">
                      <div>
                        <span>
                          {{ new Date(props.row.decommissioned_date).toLocaleDateString(language, {
                              month:
                                  '2-digit', day: '2-digit', year: 'numeric'
                              }) + " , " + new
                              Date(props.row.decommissioned_date).toLocaleTimeString(language, {hour: '2-digit',
                          minute:'2-digit'}) }}
                        </span>
                      </div>
                    </template>
                    <template slot="updated_date" slot-scope="props">
                      <div v-if="props.row.updated_date">
                        <span>
                          {{ new Date(props.row.updated_date).toLocaleDateString(language, {
                              month:
                                  '2-digit', day: '2-digit', year: 'numeric'
                              }) + " , " + new
                              Date(props.row.updated_date).toLocaleTimeString(language, {hour: '2-digit',
                          minute:'2-digit'}) }}
                        </span>
                      </div>
                    </template>
                    <template slot="update" slot-scope="props">
                      <b-button
                        @click="updateVehicle(props.row)"
                        class="btn btn-blue"
                      >
                        <fa :icon="['fas', 'pencil-alt']" size="lg" />
                      </b-button>
                    </template>
                    <template slot="decommission" slot-scope="props">
                      <b-button
                        @click="decommissionVehicle(props.row)"
                        class="btn btn-blue"
                      >
                        <fa :icon="['fas', 'trash']" size="lg" />
                      </b-button>
                    </template>
                    <template slot="recommission" slot-scope="props">
                      <b-button
                        @click="recommissionVehicle(props.row)"
                        class="btn btn-success"
                      >
                        <fa :icon="['fas', 'redo']" size="lg" />
                      </b-button>
                    </template>
                  </vue-bootstrap4-table>
                </div>
              </b-col>
            </b-row>
          </b-tab>
          <!-- Systems Tab (Active + History combined) -->
          <b-tab id="systems" title="Systems">
            <!-- Alert for successfully adding a system -->
            <b-row class="p-3" v-if="newSystemSuccess" id="NewSystemSuccessWindow">
              <b-col class="text-center">
                <span class="alert alert-success">
                  <b style="text-shadow: none">{{ this.newSystemSuccess }}</b>
                </span>
                <span class="btn" @click="newSystemSuccessHide()">
                  <fa :icon="['fas', 'window-close']" />
                </span>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <!-- Loading Spinner -->
                <div class="d-flex justify-content-center py-1" v-if="!this.dataLoaded">
                  <span
                    class="spinner-border spinner-border-md highlightLoader"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span class="highlightLoader p-1 spinner-border-md">Loading Data...</span>
                </div>
                <div v-else>
                  <div class="tableHeader">
                    <b-form-checkbox-group class="checkboxes" v-model="systemsSelectedRegions">
                      <b-form-checkbox class="custom-checkbox" size="lg" value="North America">NA</b-form-checkbox>
                      <b-form-checkbox size="lg" value="Europe">EU</b-form-checkbox>
                      <b-form-checkbox size="lg" value="Japan">JP</b-form-checkbox>
                      <b-form-checkbox size="lg" value="Middle East">ME</b-form-checkbox>
                       <!--  <b-form-checkbox size="lg" value="Australia">AUS</b-form-checkbox> -->
                    </b-form-checkbox-group>
                    <!-- Active / History toggle -->
                    <div class="mm-field">
                      <div class="vehicles-status-toggle">
                        <div
                          class="vehicle-toggle-indicator"
                          :style="{
                            transform: `translateX(${activeSystemFlag ? 0 : 100}%)`,
                            background: '#007bff'
                          }"
                        ></div>
                        <button type="button" class="vehicle-toggle-btn white-text" :class="{ active: activeSystemFlag }" @click="activeSystemFlag = true">
                          Active
                        </button>
                        <button type="button" class="vehicle-toggle-btn white-text" :class="{ active: !activeSystemFlag }" @click="activeSystemFlag = false">
                          History
                        </button>
                      </div>
                    </div>
                  </div>
                  <vue-bootstrap4-table
                    :rows="filteredSystems"
                    :columns="activeSystemFlag ? systemColumns : systemHistoryColumns"
                    :config="systemConsoleConfig"
                    :classes="classes"
                  >
                    <template slot="system" slot-scope="props">
                      <div>
                        <span>{{ props.row.system }}</span>
                      </div>
                    </template>
                    <template slot="serial_number" slot-scope="props">
                      <div>
                        <span>{{ props.row.serial_number }}</span>
                      </div>
                    </template>
                    <template slot="install_date" slot-scope="props">
                      <div v-if="props.row.install_date">
                        <span>{{ new Date(props.row.install_date).toLocaleDateString("en-US", { year: 'numeric', month: "2-digit", day: "2-digit"}) }}</span>
                      </div>
                    </template>
                    <template slot="region" slot-scope="props">
                      <div>
                        <span>{{ props.row.region }}</span>
                      </div>
                    </template>
                    <template slot="decommission_date" slot-scope="props">
                      <div>
                        <span>
                          {{
                            new Date(props.row.decommission_date).toLocaleString(
                              'en-US',
                              { day: '2-digit', month: '2-digit', year: 'numeric' }
                            )
                          }}
                        </span>
                      </div>
                    </template>
                    <template slot="update" slot-scope="props">
                      <b-button
                        @click="changeSerialNumber(props.row)"
                        class="btn btn-blue"
                      >
                        <fa :icon="['fas', 'pencil-alt']" size="lg" />
                      </b-button>
                    </template>
                    <template slot="decommission" slot-scope="props">
                      <b-button
                        @click="decommissionSystem(props.row)"
                        class="btn btn-blue"
                      >
                        <fa :icon="['fas', 'trash']" size="lg" />
                      </b-button>
                    </template>
                  </vue-bootstrap4-table>
                </div>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-container>
    </b-modal>
  </div>
</template>

<style scoped>
/* ─── Layout helpers ─────────────────────────────────────────── */
.white-text { color: white !important; }

.new-form-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.row-input {
  margin: auto;
  gap: 30px;
  width: 60%;
}

.submit { margin-top: 10px; }

.row-label-left-justify  { text-align: left; }
.text-input-left-justify { text-align: left; }

.row-label-right-justify {
  text-align: right;
  font-size: 13.5px;
  color: rgba(6, 60, 109, 0.7);
  font-weight: 500;
  letter-spacing: 0.01em;
}

/* ─── Table header (region checkboxes + toggle row) ──────────── */
.tableHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 4px 12px;
  gap: 12px;
}

.checkboxes {
  display: flex;
  gap: 14px;
  align-items: center;
}

/* ─── Loading spinner text ───────────────────────────────────── */
.highlightLoader {
  color: #063c6d;
  font-size: 13px;
}

/* ─── Inactive operator row ──────────────────────────────────── */
.inactive {
  opacity: 0.45;
  font-style: italic;
  text-decoration: line-through;
  color: #063c6d;
}

/* ─── Active / Inactive segmented toggle ─────────────────────── */
.mm-field { display: flex; align-items: center; }

.vehicles-status-toggle {
  position: relative;
  display: flex;
  border-radius: 20px;
  border: 1px solid rgba(6, 60, 109, 0.25);
  overflow: hidden;
  background: rgba(6, 60, 109, 0.05);
  height: 30px;
  min-width: 200px;
}

.vehicle-toggle-indicator {
  position: absolute;
  top: 0; bottom: 0;
  width: 50%;
  border-radius: 20px;
  transition: transform 0.2s ease;
  opacity: 0.85;
}

.vehicle-toggle-btn {
  position: relative;
  z-index: 1;
  flex: 1;
  background: transparent;
  border: none;
  font-size: 12px;
  font-weight: 500;
  padding: 0 18px;
  cursor: pointer;
  transition: color 0.15s;
  color: #063c6d;
}
.vehicle-toggle-btn.active { color: #fff; font-weight: 600; }

/* ─── Icon action buttons ────────────────────────────────────── */
/* Edit / pencil */
.btn.btn-info {
  background: transparent !important;
  border: none !important;
  color: #4db8f0 !important;
  padding: 5px 8px;
  border-radius: 4px;
  box-shadow: none !important;
  transition: background 0.15s;
}
.btn.btn-info:not(:disabled):hover { background: rgba(77, 184, 240, 0.12) !important; }
.btn.btn-info:disabled { opacity: 0.3; cursor: not-allowed; }

/* Delete / decommission */
.btn.btn-danger {
  background: transparent !important;
  border: none !important;
  color: #e05a5a !important;
  padding: 5px 8px;
  border-radius: 4px;
  box-shadow: none !important;
  transition: background 0.15s;
}
.btn.btn-danger:not(:disabled):hover { background: rgba(224, 90, 90, 0.12) !important; }
.btn.btn-danger:disabled { opacity: 0.3; cursor: not-allowed; }

/* Reactivate badge */
.btn.btn-warning {
  background: rgba(240, 180, 41, 0.14) !important;
  border: 1px solid rgba(240, 180, 41, 0.35) !important;
  color: #f0b429 !important;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  box-shadow: none !important;
}
.btn.btn-warning:hover { background: rgba(240, 180, 41, 0.25) !important; }

/* Add Road Type / form actions */
.btn.btn-success {
  background: #063c6d !important;
  border: 1px solid #063c6d !important;
  color: #fff !important;
  border-radius: 6px;
  box-shadow: none !important;
  transition: background 0.15s;
}
.btn.btn-success:hover {
  background: #0a5499 !important;
  border-color: #0a5499 !important;
  color: #fff !important;
}

/* ─── Inline success alerts ──────────────────────────────────── */
.alert.alert-success {
  background: rgba(61, 201, 155, 0.12) !important;
  border: 1px solid rgba(61, 201, 155, 0.3) !important;
  color: #3dc99b !important;
  border-radius: 6px;
  font-size: 13px;
  text-shadow: none;
}
</style>

<style>
/* ─── DPR Admin Console modal overrides (unscoped for b-modal portal) ─── */

/* Reset table's blue class background */
.dpr-admin-modal .menu-bg-blue-transparent-modal {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}

/* ─── Table styling matching EntryManager ───────────────────────────── */
.dpr-admin-modal table {
  color: #063c6d !important;
  text-shadow: none !important;
}
.dpr-admin-modal thead th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-shadow: none !important;
}
.dpr-admin-modal thead th a,
.dpr-admin-modal thead th svg {
  color: rgba(6, 60, 109, 0.5) !important;
}
.dpr-admin-modal tbody tr {
  color: #063c6d !important;
  text-shadow: none !important;
}
.dpr-admin-modal tbody tr:hover {
  background: rgba(6, 60, 109, 0.04) !important;
}
.dpr-admin-modal tbody td {
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.08) !important;
  text-shadow: none !important;
}
.dpr-admin-modal .footer-pagination-row td,
.dpr-admin-modal .footer-pagination-row th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  text-shadow: none !important;
}

/* Tabs — dark blue pill style matching other DPR modals */
.dpr-admin-modal .nav-pills .nav-link {
  color: rgba(6, 60, 109, 0.65);
  background: transparent;
  border: 1px solid rgba(6, 60, 109, 0.3);
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  margin: 0 4px;
  transition: background 0.15s;
}
.dpr-admin-modal .nav-pills .nav-link.active {
  background: #063c6d !important;
  color: #fff !important;
  border-color: #063c6d !important;
}

/* Toggle indicator — override the inline :style binding */
.dpr-admin-modal .vehicle-toggle-indicator {
  background: #063c6d !important;
  opacity: 1 !important;
}

/* Toggle buttons — active: white (on dark blue indicator); inactive: full dark blue */
.dpr-admin-modal .vehicle-toggle-btn {
  color: #063c6d !important;
}
.dpr-admin-modal .vehicle-toggle-btn.active {
  color: #fff !important;
  font-weight: 600;
}
.btn-blue {
  color: #063c6d !important;
  background-color: transparent !important;
  border-color: transparent !important;
}
</style>

<script>
import MMP_DPR_SerialNumberChange from './MMP_DPR_SerialNumberChange.vue'
import MMP_DPR_Decommission from './MMP_DPR_Decommission.vue'
import MMP_DPR_UpdateVehicle from './MMP_DPR_UpdateVehicle.vue'
import MMP_DPR_DecommissionVehicle from './MMP_DPR_DecommissionVehicle.vue'
import MMP_DPR_RecommissionVehicle from './MMP_DPR_RecommissionVehicle.vue'
import MMP_DPR_NewVehicle from './MMP_DPR_NewVehicle.vue'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import axios from 'axios'
import dpr_new_system from '!!raw-loader!../../../emails/dpr_new_system.html'
export default {
  name: 'MMP_DPR_AdminConsole',
  components: {
    MMP_DPR_SerialNumberChange,
    MMP_DPR_Decommission,
    MMP_DPR_UpdateVehicle,
    MMP_DPR_DecommissionVehicle,
    MMP_DPR_RecommissionVehicle,
    MMP_DPR_NewVehicle,
    VueBootstrap4Table
  },
  props: ['user', 'isAdmin'],
  data() {
    return {
      dataLoaded: false,
      formSubmitErrors: [],
      entryManagerRows: [],
      // Numerical columns do not sort correctly
      operatorColumns: [
        {
          label: 'Name',
          name: 'name',
          sort: false
        },
        {
          label: 'Operator Group',
          name: 'group',
          sort: true
        },
        {
          label: 'Inactive Date',
          name: 'deleted_date',
          sort: false
        },
        {
          label: 'Update',
          name: 'update',
          sort: false
        },
        {
          label: 'Make Inactive',
          name: 'delete',
          sort: false
        }
      ],
      actions: [
        {
          btn_text: 'Add New Operator',
          event_name: 'newUser',
          event_payload: {
            msg: 'Add new operator'
          },
          class: 'btn btn-success'
        }
      ],
      vehiclesActions: [
        {
          btn_text: 'Add New Vehicle',
          event_name: 'newVehicle',
          event_payload: {
            msg: 'Add new vehicle'
          },
          class: 'btn btn-success'
        }
      ],
      operatorConsoleConfig: {
        checkbox_rows: false,
        rows_selectable: true,
        card_mode: false,
        global_search: {
          placeholder: 'Search...',
          visibility: true,
          showClearButton: true,
          searchOnPressEnter: true
        },
        highlight_row_hover_color: '#4a4a4a',
        show_refresh_button: false,
        show_reset_button: false
      },
      roadTypeColumns: [
        {
          label: 'Type',
          name: 'type',
          sort: false
        },
        {
          label: 'Update',
          name: 'update',
          sort: false
        },
        {
          label: 'Delete',
          name: 'delete',
          sort: false
        }
      ],
      roadTypeConsoleConfig: {
        checkbox_rows: false,
        rows_selectable: true,
        card_mode: false,
        global_search: {
          placeholder: 'Search...',
          visibility: true,
          showClearButton: true,
          searchOnPressEnter: true
        },
        highlight_row_hover_color: '#4a4a4a',
        show_refresh_button: false,
        show_reset_button: false
      },
      activeVehiclesColumns: [
        {
          label: 'Vehicle Name',
          name: 'vehicle_name',
          sort: true,
        },
        {
          label: 'Region',
          name: 'region',
          sort: true
        },
        {
          label: 'Last Updated By',
          name: 'updated_user',
          sort: false
        },
        { 
          label: 'Last Updated Date',
          name: 'updated_date',
          sort: true
        },
        {
          label: 'Update',
          name: 'update',
          sort: false
        },
        {
          label: 'Decommission',
          name: 'decommission',
          sort: false
        }
      ],
      inactiveVehiclesColumns: [
        {
          label: 'Vehicle Name',
          name: 'vehicle_name',
          sort: true,
        },
        {
          label: 'Region',
          name: 'region',
          sort: true
        },
        {
          label: 'Last Updated By',
          name: 'updated_user',
          sort: false
        },
        { 
          label: 'Last Updated Date',
          name: 'updated_date',
          sort: true
        },
        {
          label: 'Decommission Date',
          name: 'decommissioned_date',
          sort: true
        },
        {
          label: 'Recommission',
          name: 'recommission',
          sort: false
        }
      ],
      systemColumns: [
        {
          label: 'Vehicle',
          name: 'system',
          sort: true,
        },
        {
          label: 'Scanner',
          name: 'scanner',
          sort: true
        },
        {
          label: 'Scanner Serial Number',
          name: 'serial_number',
          sort: true
        },
        {
          label: 'Install Date',
          name: 'install_date',
          sort: true
        },
        {
          label: 'Region',
          name: 'region',
          sort: true
        },
        {
          label: 'Update',
          name: 'update',
          sort: false
        },
        {
          label: 'Decommission',
          name: 'decommission',
          sort: false
        }
      ],
      systemHistoryColumns: [
        {
          label: 'Vehicle',
          name: 'system',
          sort: true
        },
        {
          label: 'Scanner',
          name: 'scanner',
          sort: true
        },
        {
          label: 'Scanner Serial Number',
          name: 'serial_number',
          sort: true
        },
        {
          label: 'Install Date',
          name: 'install_date',
          sort: true
        },
        {
          label: 'Decommission Date',
          name: 'decommission_date',
          sort: true
        },
        {
          label: 'Region',
          name: 'region',
          sort: true
        }
      ],
      systemConsoleConfig: {
        checkbox_rows: false,
        rows_selectable: true,
        card_mode: false,
        global_search: {
          placeholder: 'Search...',
          visibility: true,
          showClearButton: true,
          searchOnPressEnter: true
        },
        highlight_row_hover_color: '#4a4a4a',
        preservePageOnDataChange: true,
        show_refresh_button: false,
        show_reset_button: false
      },
      newOperatorInput: '',
      newRoadTypeInput: '',
      newRoadTypeSuccess: '',
      updateRoadTypeSuccess: '',
      deleteRoadTypeSuccess: '',
      newOperatorSuccess: '',
      newSystemInput: '',
      newSystemSuccess: '',
      operators: [],
      roadTypes: [],
      systems: [],
      systemsHistory: [],
      operatorInputs: ['1'],
      updateEntryID: null,
      showTruckHoursAlert: false,
      hideInactive: true,
      classes: {
        table: {
          'menu-bg-blue-transparent-modal': true
        }
      },
      incomingData: {
        region: null,
        scanner: null,
        serialNumber: null,
        systemName: null,
        systemType: null
      },
      newSystemForm: {
        lidar: {
          ftp_name: '',
          prefix: '',
          raw_data_site: '',
          sys_id: ''
        },
        scanner: 0,
        scannerSerialNumber: '',
        system: '',
        region: ''
      },
      newSystemFormRegionOptions: ['North America', 'Europe', 'Japan', 'Middle East', 'Australia'],
      updateNewSystemForm: {
        scanner: 0,
        system_type: null,
        serial_number: '',
        install_date: new Date(),
        system: '',
        region: null
      },
      regionOptions: [
        'North America',
        'Japan',
        'Europe',
        'Middle East',
        'Australia'
      ],
      systemTypeOptions: [
        'cm_only',
        'new_miles_only',
        'cm_new_miles'
      ],
      activeTab: 0,
      activeSystemFlag: true,
      systemsSelectedRegions: ['North America', 'Europe', 'Japan', 'Middle East', 'Australia'],
      vehiclesSelectedRegions: ['North America', 'Europe', 'South Korea', 'Japan', 'Middle East'],
      numDriversError: '',
      removeDriverBtnDisabled: false,
      addDriverBtnDisabled: false,
      maxNumDrivers: 3,
      deletedFeedback: '',
      dpr_new_system_recipients: [],
      vehicles: [],
      vehicleToUpdate: null,
      vehicleToDecommission: null,
      vehicleToRecommission: null,
      activeVehicleFlag: true,
      language: navigator.language
    }
  },
  methods: {
    updateVehicle(row) {
      this.vehicleToUpdate = row
      this.$bvModal.show('updateVehicleModal')
    },
    decommissionVehicle(row) {
      this.vehicleToDecommission = row
      this.$bvModal.show('decommissionVehicleModal')
    },
    recommissionVehicle(row) {
      this.vehicleToRecommission = row
      this.$bvModal.show('recommissionVehicleModal')
    },
    async getVehicles() {
      if (sessionStorage.token) {
        await axios
          .get(process.env.API_LOCATION + '/api/dpr/acquisitionVehicles', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              isAdmin: this.isAdmin
            }
          })
          .then(response => {
            const content = response.data
            // If duplicate entry found, throw error and prevent submission
            if (content.errors) {
              console.log('Operator API Call Error: ' + content.errors)
            } else {
              this.vehicles = content
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    async changeSerialNumber(row) {
      this.incomingData = {
        region: row.region,
        scanner: row.scanner,
        serialNumber: row.serial_number,
        systemName: row.system,
        systemType: row.system_type
      }
      this.$bvModal.show('serialNumberChangeModal')
    },
    async decommissionSystem(row) {
      this.incomingData = {
        region: row.region,
        scanner: row.scanner,
        serialNumber: row.serial_number,
        systemName: row.system
      }
      this.$bvModal.show('decommissionModal')
    },
    sendEmail() {
      const fromEmail = 'mmp-info@dmp-maps.com'
      const toEmail = [] // 'nshinde@dmp-maps.com' , 'psurnis@dmp-maps.com', 'nschweikhart@dmp-maps.com'
      const emailSubject = 'New Acquisition System Added'

      let formattedDate = new Date(this.updateNewSystemForm.install_date).toISOString().split('T')[0];
      let year = new Date().getFullYear()

      const emailBody = dpr_new_system
              .replace('{{ systemName }}', this.updateNewSystemForm.system)
              .replace('{{ systemType }}', this.updateNewSystemForm.system_type)
              .replace('{{ scannerNumber }}', this.updateNewSystemForm.scanner)
              .replace('{{ scannerSerial }}', this.updateNewSystemForm.scannerSerialNumber)
              .replace('{{ region }}', this.updateNewSystemForm.region)
              .replace('{{ installDate }}', formattedDate)
              .replace('{{ userName }}', this.user.name)
              .replace('{{ userEmail }}', this.user.email)
              .replace('{{ year }}', year)

      if (sessionStorage.token) {
            axios.post(
                process.env.API_LOCATION + '/api/email/sendemail',
                {
                    fromEmail: fromEmail,
                    toEmail: this.dpr_new_system_recipients,
                    emailSubject: emailSubject,
                    emailBody: emailBody
                },
                {
                    headers: {
                        'x-auth-token': sessionStorage.token
                    }
                }
            ).then(response => {
                const content = response.data
                if (content.errors) {
                    console.log('sendEmail API Call Error')
                } else {
                    if (content.some(obj => obj.status !== 'bounced' || obj.status !== 'rejected')) {
                        this.$bvToast.toast('Email sent.', {
                            autoHideDelay: 5000,
                            variant: 'success',
                            solid: true,
                            title: 'Email Sent',
                            toaster: 'b-toaster-top-center'
                        })
                        //this.$bvModal.hide('InformationModal')
                    }
                }
            })
            .catch(function (error) {
                console.log(error)
                self.feedback = error.response.data.errors[0].msg
                self.showFeedback()
            })
      } else {
        console.log('No User Token')
      }
    },
    submitUpdatedNewSystemForm() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/dpr/addNewSystemUpdated', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              scanner: this.updateNewSystemForm.scanner,
              system_type: this.updateNewSystemForm.system_type,
              scanner_serial_number: this.updateNewSystemForm.scannerSerialNumber,
              system: this.updateNewSystemForm.system,
              install_date: this.updateNewSystemForm.install_date,
              region: this.updateNewSystemForm.region
            }
          })
          .then(async (response) => {
            const content = response.data
            if (content.errors) {
              console.log('addNewSystemUpdated API Call Error: ' + content.errors)
              this.$bvModal.hide('updatedNewSystemConfirmation')
              this.$bvToast.toast(content.errors, {
                autoHideDelay: 10000,
                variant: 'danger',
                title: 'New System Form Error',
                toaster: 'b-toaster-top-center'
              })
            } else {
              await this.sendEmail();
              // Gets active systems
              this.getSystems(this, false)
              // Gets system history
              this.getSystems(this, true)
              this.$bvModal.hide('updatedNewSystemConfirmation')
              // Jump to Scanners Tab
              this.activeTab = 4;
              // Success Msg
              this.$bvToast.toast("New System Successfully Submitted.", {
                autoHideDelay: 10000,
                title: 'New System Form Response',
                toaster: 'b-toaster-top-center'
              })

              this.updateNewSystemForm = {
                system: null,
                system_type: null,
                scanner: 0,
                scannerSerialNumber: null,
                install_date: new Date(),
                region: null
              }
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    async validateNewSystemInputs() {
      let errMsg = ''

      // Confirm none of the inputs are null
      if (!this.updateNewSystemForm.system || !this.updateNewSystemForm.scannerSerialNumber || !this.updateNewSystemForm.region ||
          !this.updateNewSystemForm.install_date || !this.updateNewSystemForm.system_type) {
        errMsg += 'New System Form is not complete. Please provide '

        if (!this.updateNewSystemForm.system) {
          errMsg += 'System Name, '
        }
        if (!this.updateNewSystemForm.system_type) {
          errMsg += 'System Type, '
        }
        if (!this.updateNewSystemForm.scannerSerialNumber) {
          errMsg += 'Scanner Serial Number, '
        }

        if (!this.updateNewSystemForm.region) {
          errMsg += 'Region, '
        }

        if (!this.updateNewSystemForm.install_date) {
          errMsg += 'Install Date'
        }

        errMsg += '.'
        errMsg = errMsg.replace(', .', '.')

        this.$bvToast.toast(errMsg, {
          autoHideDelay: 10000,
          variant: 'danger',
          solid: true,
          title: 'New System Form Error',
          toaster: 'b-toaster-top-right'
        })

        return false;
      }

      if (sessionStorage.token) {
        let bool = true;
        await axios
          .get(process.env.API_LOCATION + '/api/dpr/checkDuplicateSystem', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              scanner: this.updateNewSystemForm.scanner,
              system_type: this.updateNewSystemForm.system_type, // may not be needed here
              scanner_serial_number: this.updateNewSystemForm.scannerSerialNumber,
              system: this.updateNewSystemForm.system,
              install_date: this.updateNewSystemForm.install_date,
              region: this.updateNewSystemForm.region
            }
          })
          .then(response => {
            const content = response.data.rows
            if (content.errors) {
              console.log('checkDuplicateSystem API Call Error: ' + content.errors)
            } else {
              if (content.length > 0) {
                errMsg = `System with System Name '${this.updateNewSystemForm.system}', 
                          Scanner '${this.updateNewSystemForm.scanner}', 
                          Scanner Serial Number '${this.updateNewSystemForm.scannerSerialNumber}', 
                          and Install Date of '${this.updateNewSystemForm.install_date.toLocaleDateString()}' already exists for Region '${this.updateNewSystemForm.region}'`

                this.$bvToast.toast(errMsg, {
                  autoHideDelay: 10000,
                  variant: 'danger',
                  solid: true,
                  title: 'New System Form Error',
                  toaster: 'b-toaster-top-right'
                })

                bool = false;
              } 
            }
          })
          .catch(function (error) {
            console.log(error)
          })
        
        return bool;
      } else {
        console.log('No User Token')
      }
    },
    // WEBGIS-2558 - Code not used anymore, replaced with new function
    // async showNewSystemConfirmation() {
    //   let validation = await this.validateNewSystemInputs()
    //   if (!validation) {
    //     return;
    //   }
    //   this.$bvModal.show('newSystemConfirmation')
    // },
    async showUpdatedNewSystemConfirmation() {
      let validation = await this.validateNewSystemInputs()
      if (!validation) {
        return;
      }
      this.$bvModal.show('updatedNewSystemConfirmation')
    },
    // WEBGIS-2558 - Code not used anymore, replaced with new function
    // submitNewSystem() {
    //   if (sessionStorage.token) {
    //     axios
    //       .get(process.env.API_LOCATION + '/api/dpr/addNewSystem', {
    //         headers: {
    //           'x-auth-token': sessionStorage.token
    //         },
    //         params: {
    //           lidar_ftp_name: this.newSystemForm.lidar.ftp_name,
    //           lidar_prefix: this.newSystemForm.lidar.prefix,
    //           lidar_raw_data_site: this.newSystemForm.lidar.raw_data_site,
    //           lidar_sys_id: this.newSystemForm.lidar.sys_id,
    //           scanner: this.newSystemForm.scanner,
    //           scanner_serial_number: this.newSystemForm.scannerSerialNumber,
    //           system: this.newSystemForm.system,
    //           region: this.newSystemForm.region
    //         }
    //       })
    //       .then(response => {
    //         const content = response.data
    //         if (content.errors) {
    //           console.log('API Call Error: ' + content.errors)
    //         } else {
    //           // Gets active systems
    //           this.getSystems(this, false)
    //           // Gets system history
    //           this.getSystems(this, true)
    //           this.$bvModal.hide('newSystemConfirmation')
    //         }
    //       })
    //       .catch(function (error) {
    //         console.log(error)
    //       })
    //   } else {
    //     console.log('No User Token')
    //   }
    // },
    // Executes when the Entry Manager button is clicked
    async getOperators() {
      if (sessionStorage.token) {
        await axios
          .get(process.env.API_LOCATION + '/api/dpr/operator', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            // If duplicate entry found, throw error and prevent submission
            if (content.errors) {
              console.log('Operator API Call Error: ' + content.errors)
            } else {
              this.operators = content.rows
              if (this.hideInactive) {
                this.operators = this.operators.filter(
                  op => op.deleted_date === null
                )
              }
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    async getRoadTypes() {
      if (sessionStorage.token) {
        await axios
          .get(process.env.API_LOCATION + '/api/dpr/roadType', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            // If duplicate entry found, throw error and prevent submission
            if (content.errors) {
              console.log('Road Types API Call Error: ' + content.errors)
            } else {
              this.roadTypes = content.rows
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    getSystems: async (self, history) => {
      if (sessionStorage.token) {
        if (history) {
          self.systemsHistory = []
          self.systemsHistory = [
            ...(await self.getRegionSystems('NA', true)),
            ...(await self.getRegionSystems('EU', true)),
            ...(await self.getRegionSystems('JP', true)),
            ...(await self.getRegionSystems('ME', true)),
         //  ...(await self.getRegionSystems('AUS', true))
          ]
        } else {
          self.systems = []
          self.systems = [
            ...(await self.getRegionSystems('NA', false)),
            ...(await self.getRegionSystems('EU', false)),
            ...(await self.getRegionSystems('JP', false)),
            ...(await self.getRegionSystems('ME', false)),
           // ...(await self.getRegionSystems('AUS', false))
          ]
        }
      } else {
        console.log('No User Token')
      }
    },
    getRegionSystems: async (region, gettingHistory) => {
      let retVal = await axios
        .get(process.env.API_LOCATION + '/api/dpr/vehicles', {
          headers: {
            'x-auth-token': sessionStorage.token
          },
          params: {
            gettingHistory: gettingHistory,
            region: region
          }
        })
        .then(response => {
          const content = response.data
          if (content.errors) {
            console.log('Vehicles API Call Error: ' + content.errors)
            return []
          } else {
            return content
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      return retVal
    },
    updateSystems(obj) {
      let region = obj.region
      let snAdd = obj.serialNumberAdd
      let snRemove = obj.serialNumberRemove
      let system = obj.system

      let index = this.systems.findIndex(sys => {
        return (
          sys.region == region &&
          sys.serial_number == snRemove &&
          sys.system == system
        )
      })

      if (snAdd) {
        this.systems[index].serial_number = snAdd
      } else {
        this.systems.splice(index, 1)
      }

      // Gets active systems
      this.getSystems(this, false)
      // Gets system history
      this.getSystems(this, true)
      this.$bvModal.hide('serialNumberChangeModal')
      this.$bvModal.hide('decommissionModal')
    },
    addOperator() {
      this.numDriversError = ''
      this.removeDriverBtnDisabled = false
      if (this.operatorInputs.length < this.maxNumDrivers) {
        this.operatorInputs.push(String(this.operatorInputs.length + 1))
      } else {
        this.numDriversError = 'Maximum number of Operators'
        this.addDriverBtnDisabled = true
      }
    },
    newOperatorSuccessHide() {
      this.newOperatorSuccess = ''
    },
    deleteOperator(props) {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/dpr/deleteOperator', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              id: props.id
            }
          })
          .then(response => {
            props.deleted_date = this.formatDateForDisplay(new Date())
            axios
              .get(
                'http://localhost:5000' + '/api/users/deleteUser/' + props.userid,
                {
                  headers: {
                    'x-auth-token': sessionStorage.token
                  },
                  params: {
                    id: props.userid
                  }
                }
              )
              .then(response => {
                const content = response.data
                if (content.errors) {
                  console.log('Update Entry API Call Error: ' + content.errors)
                  // Else no errors and we can load returned entry into form
                } else {
                  this.deletedFeedback =
                    'User account for ' + props.name + ' is deleted.'
                }
              })
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    updateOperator(props) {
      props.unmodifiedName = props.name
      props.update = true
    },
    cancelChangeOperatorName(props) {
      props.name = props.unmodifiedName
      props.update = false
    },
    newRoadType() {
      if (this.newRoadTypeInput.length > 0) {
        if (sessionStorage.token) {
          axios
            .get(process.env.API_LOCATION + '/api/dpr/newRoadType', {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                newRoadType: this.newRoadTypeInput
              }
            })
            .then(response => {
              this.newRoadTypeSuccess =
                'New RoadType ID: ' + response.data.id + ' Created'
              this.newRoadTypeInput = ''
              this.getRoadTypes()
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          console.log('No User Token')
        }
      }
    },
    newRoadTypeSuccessHide() {
      this.newRoadTypeSuccess = ''
    },
    updateRoadType(props) {
      props.unmodifiedName = props.type
      props.update = true
    },
    changeRoadTypeName(props) {
      const entryID = props.id
      if (sessionStorage.token) {
        axios
          .put(process.env.API_LOCATION + '/api/dpr/updateRoadTypeName', null, {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              newRoadTypeName: props.type,
              id: entryID
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log(
                'Update road type name API call error: ' + content.errors
              )
            } else {
              this.updateRoadTypeSuccess = 'RoadType updated to ' + props.type
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
      // Close text input box
      props.update = false
    },
    updateRoadTypeSuccessHide() {
      this.updateRoadTypeSuccess = ''
    },
    cancelChangeRoadTypeName(props) {
      props.type = props.unmodifiedName
      props.update = false
    },
    deleteRoadType(props) {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/dpr/deleteRoadType', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              id: props.id
            }
          })
          .then(response => {
            this.deleteRoadTypeSuccess = 'RoadType deleted.'
            this.getRoadTypes()
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    deleteRoadTypeSuccessHide() {
      this.deleteRoadTypeSuccess = ''
    },
    newSystemSuccessHide() {
      this.newSystemSuccess = ''
    },
    formatDateForDisplay(date) {
      if (date == null) {
        return
      }
      const newDate = new Date(date)
      return (
        (newDate.getMonth() + 1).toString().padStart(2, '0') +
        '-' +
        newDate.getDate().toString().padStart(2, '0') +
        '-' +
        newDate.getFullYear()
      )
    },
    reactivateOperator(row) {
      let operatorToReactivateID = row.id
      if (confirm('Confirm reactivate operator ' + row.name)) {
        if (sessionStorage.token) {
          axios
            .get(process.env.API_LOCATION + '/api/dpr/reactivateOperator', {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                id: operatorToReactivateID
              }
            })
            .then(response => {
              row.deleted_date = null
            })
            .catch(function (error) {
              console.log(error)
            })
          axios
            .get(process.env.API_LOCATION + '/api/dpr/reactivateUser', {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                id: row.userid
              }
            })
            .then(response => {
              row.deleted_date = null
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          console.log('No User Token')
        }
      }
    },
    closeAdminConsole() {
      this.$bvModal.hide('adminConsoleModal')
    },
    initNewUserModal() {
      this.closeAdminConsole()
      this.$bvModal.show('NewUserModal')
      this.$parent.$parent.$refs.newUserModalRef.resetUACforAcquisitionAdmin()
    },
    updateOperatorDetails(props) {
      const userid = props.userid
      this.closeAdminConsole()
      this.$emit('updateUser', userid)
    },
    loadAdminConsole() {
      this.$nextTick(async () => {
        this.dataLoaded = false;
        await this.getOperators()
        await this.getRoadTypes()
        await this.getVehicles()
        // Gets active systems
        await this.getSystems(this, false)
        // Gets system history
        await this.getSystems(this, true)
        this.dataLoaded = true
      })
    },
    getDPRNewSystemEmailRecipients() {
      if (sessionStorage.token) {
        axios.get(process.env.API_LOCATION + '/api/email/getRecipients', {
          headers: {
            'x-auth-token': sessionStorage.token
          },
          params: {
            module: 'dpr_new_system'
          }
        })
        .then(response => {
          this.dpr_new_system_recipients = response.data[0].recipients;
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        console.log('No User Token')
      }
    }
  },
  mounted() {
    this.getDPRNewSystemEmailRecipients();
  },
  computed: {
    filteredSystems() {
      const source = this.activeSystemFlag ? this.systems : this.systemsHistory
      return source.filter(system => this.systemsSelectedRegions.includes(system.region))
    },
    filteredVehicles() {
      const regionOrder = ['North America', 'Europe', 'South Korea', 'Japan', 'Middle East']
      return this.vehicles
        .filter(vehicle => this.vehiclesSelectedRegions.includes(vehicle.region))
        .filter(vehicle => {
          const isActive = vehicle.decommissioned == null || vehicle.decommissioned == false
          return this.activeVehicleFlag ? isActive : !isActive
        })
        .sort((a, b) => {
          const ai = regionOrder.indexOf(a.region)
          const bi = regionOrder.indexOf(b.region)
          return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi)
        })
    }
  }
}
</script>
